import { render, staticRenderFns } from "./RecebimentoGrid.vue?vue&type=template&id=6fe5511a"
import script from "./RecebimentoGrid.vue?vue&type=script&lang=js"
export * from "./RecebimentoGrid.vue?vue&type=script&lang=js"
import style0 from "./RecebimentoGrid.vue?vue&type=style&index=0&id=6fe5511a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports